<script>
import {mapActions, mapMutations, mapGetters} from 'vuex';
import edit from './codeEdit';
import config from '@/modules/config/columns';
export default {
	props: {
		handlerCodeSearch: {
			type: Function,
			required: true
		},
		searchQuery: {
			type: Object,
			required: true
		},
		selectOption: {
			type: Object,
			required: true
		}
	},
	data() {
        return {
        }
    },
	methods: {
		addCodeModel() {
			this.$refs.edit.modelStatus(true);
		},
		reset() {
			this.$clearObject(this.searchQuery);
		},
		change() {
			this.$emit('change')
		},
		...mapActions('nameRules', ['addCode']),
		...mapMutations('nameRules', {
			changeCodeValue: 'CHANGE_CODE_VALUE'
		})
	},
	computed: {
		...mapGetters('nameRules', ['codeOption']),
		config() {
			return config;
		}
	},
	components: {
		edit
	}
}
</script>
<template>
<div class="name-search">
	<el-row :gutter="20">
	    <!-- <el-col :span="6">
	  	    <el-input v-model ="searchQuery.id" placeholder="政策编号"></el-input>
	    </el-col> -->
	    <el-col :span="6">
	        <el-input v-model="searchQuery.title" @change="change" placeholder="政策标题" clearable></el-input>
	    </el-col>
	    <el-col :span="6">
			<el-select v-model="searchQuery.infoTypeId" class="common-width" @change="change" placeholder="政策类型">
				<el-option
					v-for="item in selectOption.infoTypeId"
					:key="item.key"
					:label="item.typeName"
					:value="item.key"

				>
				</el-option>
			</el-select>
	    </el-col>
		<el-col :span="6">
			<el-select v-model="searchQuery.authStatus" class="common-width"
			    placeholder="审核状态"
				@change="change"
			>
				<el-option
					v-for="item in selectOption.authStatus"
					:key="item.key"
					:label="item.typeName"
					:value="item.key"
				>
				</el-option>
			</el-select>
	    </el-col>
        <el-col :span="6">
			<el-date-picker class="common-width"
				v-model="searchQuery.queryTimeBegin"
				type="date"
				placeholder="选择开始日期"
				value-format="yyyy-MM-dd"
				@change="change"
			>
			</el-date-picker>
	    </el-col>
	</el-row><br/>
	<el-row :gutter="20">

		<el-col :span="6">
			<el-date-picker class="common-width"
				v-model="searchQuery.queryTimeEnd"
				type="date"
				placeholder="选择结束日期"
				value-format="yyyy-MM-dd"
				@change="change"
			>
			</el-date-picker>
	    </el-col>
		<el-col :span="6">
	        <el-button type="primary" @click="handlerCodeSearch">搜索</el-button>
			<el-button type="primary" @click="reset">重置</el-button>
    	    <!-- <el-button type="primary" @click="addCodeModel">新增字段</el-button> -->
	    </el-col>
	</el-row>
	<!-- <edit ref="edit"
	  title="新增字段"
	  dialogWidth="40%"
	  :codeEvent="addCode"
	  :searchEvent="handlerCodeSearch"
	></edit> -->
</div>
</template>
<style scoped lang="stylus">
.el-header
    line-height 60px
    padding 0 10px
.avatar-uploader
    display inline-block
    margin-left 80%

/deep/.el-date-editor.el-input, .el-date-editor.el-input__inner
    width auto
</style>
